import { makeStyles } from '@material-ui/core/styles'
import { DESKTOP_FONT_SIZE } from '@v4/constants/pages'

const useStyles = makeStyles(
	theme => ({
		root: {
			border: `1px ${theme.palette.scoreapp.border} solid`,
			backgroundColor: theme.palette.scoreapp.background,
			borderRadius: 4,
			color: theme.palette.scoreapp.text,
			fontSize: DESKTOP_FONT_SIZE.subtitle2,
			padding: theme.spacing(0, 1),
			boxShadow: '0 2px 4px rgba(0, 0, 0, 0.06)',
			fontWeight: 500,
			zIndex: 3,
			height: theme.spacing(3.25),
			width: theme.spacing(20),
			pointerEvents: 'all',
		},
		select: {
			display: 'flex',
			alignItems: 'center',
			width: '100%',
			padding: 0,
			background: 'none !important',
		},
		icon: {
			color: theme.palette.scoreapp.primary,
		},

		circle: {
			fontSize: 12,
			marginRight: 6,
		},

		paper: {
			backgroundColor: 'white',
			color: theme.palette.scoreapp.text,
			width: theme.spacing(20),
			transform: 'translate(-9px, 3px) !important',
			boxShadow: '0 2px 4px rgba(0, 0, 0, 0.06)',
			borderRadius: '0 0 4px 4px',
			border: `1px ${theme.palette.scoreapp.primary} solid`,
			borderTop: 'none',
		},
		list: {
			padding: 0,
		},

		item: {
			display: 'flex',
			alignItems: 'center',
			padding: theme.spacing(0.7, 1),
		},
		text: {
			textOverflow: 'ellipsis',
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			fontSize: 15,
			fontWeight: 400,
			fontFamily: 'brandon-grotesque',
		},
	}),
	{ name: 'ScoreTierDropdown' },
)

export default useStyles
